import React from "react";
import { motion } from "framer-motion";

const AdvancedHeartGraph: React.FC = () => {
    return (
        <div className="space-y-3" dir="rtl">
            <div>
                <h4 className="font-medium text-[#002B5C] mb-1">تغییرپذیری ضربان قلب</h4>
                <div className="grid grid-cols-3 gap-3 mb-3">
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#FF4F00]">۴۳ میلی‌ثانیه</div>
                        <div className="text-xs text-[#9EA3A9]">RMSSD</div>
                    </div>
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#FF4F00]">۸.۲</div>
                        <div className="text-xs text-[#9EA3A9]">SDNN</div>
                    </div>
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#FF4F00]">خوب</div>
                        <div className="text-xs text-[#9EA3A9]">وضعیت</div>
                    </div>
                </div>
                <div className="text-xs text-[#9EA3A9] mb-2">تشخیص آریتمی</div>
                <div className="flex items-center flex-row">
                    <svg className="w-4 h-4 text-[#32D74B]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    <span className="text-sm mr-2">هیچ ناهنجاری تشخیص داده نشده است</span>
                </div>
            </div>
        </div>
    );
};

export default AdvancedHeartGraph;
